import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { StreetIcon, MapIcon } from "./Icons";
import { View } from "./View";
import { setStreetView } from "../reducers/map";
import { streetViewSelector } from "../reducers/map/selectors";

const useStyles = makeStyles({
  container: {
    cursor: "pointer",
    width: "26px",
    height: "26px",
    borderRadius: "2px",
    position: "absolute",
    backgroundColor: "white",
    inset: "auto 10px 104px auto",
    boxShadow: "rgb(0 0 0 / 30%) 0px 1px 4px",
    opacity: "0.95",
    zIndex: "10",
  },
  icon: {
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
});

export const StreetViewController = () => {
  const styles = useStyles();
  const streetView = useSelector(streetViewSelector);
  const dispatch = useDispatch();

  const onClick = () => dispatch(setStreetView(!streetView));

  return (
    <View className={styles.container} onClick={onClick}>
      {!streetView ? (
        <StreetIcon className={styles.icon} />
      ) : (
        <MapIcon className={styles.icon} />
      )}
    </View>
  );
};
